// @flow

import { handleError } from '@tectonics/alert-handler';

import accessImageSrc from './images/access_bank.svg';
import ecobankImageSrc from './images/ecobank.svg';
import fidelityImageSrc from './images/fidelity_bank.svg';
import fbnImageSrc from './images/first_bank_of_nigeria.svg';
import fcmImageSrc from './images/first_city_monument_bank.svg';
import gtImageSrc from './images/guaranty_trust_bank.svg';
import heritageImageSrc from './images/heritage_bank.svg';
import keystoneImageSrc from './images/keystone_bank.svg';
import stanbicImageSrc from './images/stanbic_ibtc_bank.svg';
import sterlinkImageSrc from './images/sterlink_bank.svg';
import unionImageSrc from './images/union_bank.svg';
import ubaImageSrc from './images/united_bank_for_africa.svg';
import unityImageSrc from './images/unity_bank.svg';
import vfdImageSrc from './images/vfd_microfinance_bank.svg';
import wemaImageSrc from './images/wema_bank.svg';
import zenithImageSrc from './images/zenith_bank.svg';

export function getBankListImageSrc(bankName: string): string {
  switch (bankName) {
    case 'access_bank':
      return accessImageSrc;
    case 'ecobank':
      return ecobankImageSrc;
    case 'fidelity_bank':
      return fidelityImageSrc;
    case 'first_bank_of_nigeria':
      return fbnImageSrc;
    case 'first_city_monument_bank':
      return fcmImageSrc;
    case 'guaranty_trust_bank':
      return gtImageSrc;
    case 'heritage_bank':
      return heritageImageSrc;
    case 'keystone_bank':
      return keystoneImageSrc;
    case 'stanbic_ibtc_bank':
      return stanbicImageSrc;
    case 'sterlink_bank':
      return sterlinkImageSrc;
    case 'union_bank':
      return unionImageSrc;
    case 'united_bank_for_africa':
      return ubaImageSrc;
    case 'unity_bank':
      return unityImageSrc;
    case 'vfd_microfinance_bank':
      return vfdImageSrc;
    case 'wema_bank':
      return wemaImageSrc;
    case 'zenith_bank':
      return zenithImageSrc;

    default: {
      handleError(new Error(`getBankListImageSrc - there is no image source for "${bankName}"`));
      return '';
    }
  }
}
